import React from "react";
import { useNavigate } from "react-router-dom";
import { useBottomNavbarContext } from "../context/BottomNavBarContext";


// Imports


const labsData = [
  {
    link: "labs/dr-lal-pathLabs",
    img: "/assets/drlal.svg",
  },
  {
    link: "labs/redcliffe-labs",
    img: "/assets/redcliffee.svg",
  },
  {
    link: "labs/agilus-diagnostics",
    img: "/assets/agilus.svg",
  },
  {
    link: "labs/pathkind-labs",
    img: "/assets/pathkind.svg",
  },
  {
    link: "labs/metropolis-healthcare",
    img: "/assets/metropolis.svg",
  }
];


const RecommendedLabs = () => {
  const navigate = useNavigate();
  const { 
    setIsHomeActive,
    setIsTestsActive,
    setIsPackagesActive,
    setIsRadiologyActive,
    setIsProfileActive,
  } = useBottomNavbarContext(); 

  const handleNavigateClick = (link) =>  {
    setIsHomeActive(false);
    setIsTestsActive(false);
    setIsPackagesActive(false);
    setIsRadiologyActive(false);
    setIsProfileActive(false);
    navigate(link)
  }
  

  return (
    <div className="w-full h-fit bg-white flex flex-col justify-start items-center  lg:p-[2%] space-y-[5%] lg:space-y-[1%]">
      {/* <TitleText text="Our Partner Labs" /> */}
        <span className="font-semibold w-3/4 text-lg text-center sm:text-[22px] lg:text-[24px] text-textPrimaryColor">
            Our Partner Labs
        </span>
      <div className="w-full h-fit flex flex-wrap justify-center items-center space-x-2 lg:space-x-6">
        {labsData?.map((lab, index) => (
          <img
            src={lab.img}
            alt="recommended-labs"
            key={index}
            loading="lazy"
            className="w-[100px] lg:w-32 h-[100px] lg:h-32 rounded-full shadow-xl object-cover cursor-pointer lg:mr-0 mb-2 lg:mb-0"
            onClick={()=>handleNavigateClick(lab.link)}
          />
        ))}
      </div>
    </div>
  );
};

export default RecommendedLabs;
